import SharedSupportTicket from "../../default/components/SupportTicket";

const SupportTicket = (props) => {
    return <SharedSupportTicket variant="partner-service" {...props} />;
};

export default SupportTicket;